module.exports = __webpack_public_path__ + "media/images/landing/dark-circles-2f6bcd03e70a2c737961670a99a27a5c.jpg";